// Utilities for parsing video embed input (URL or raw <iframe>)
export function parseEmbed(input) {
  if (!input) return null;
  const s = String(input).trim();
  // Raw iframe HTML — extract src
  if (s.toLowerCase().startsWith("<iframe")) {
    const m = s.match(/\bsrc\s*=\s*["']([^"']+)["']/i);
    if (m && m[1]) return m[1];
    return null;
  }
  try {
    const u = new URL(s);
    if (u.hostname.includes("youtu.be")) {
      const id = u.pathname.slice(1);
      return id ? `https://www.youtube.com/embed/${id}` : null;
    }
    if (u.hostname.includes("youtube.com")) {
      if (u.pathname.startsWith("/embed/")) return s;
      const id = u.searchParams.get("v") || u.pathname.split("/").pop();
      return id ? `https://www.youtube.com/embed/${id}` : null;
    }
    return s;
  } catch {
    return null;
  }
}

// Append autoplay=1 to any embed URL
export function withAutoplay(url) {
  if (!url) return url;
  try {
    const u = new URL(url);
    u.searchParams.set("autoplay", "1");
    if (u.hostname.includes("youtube.com") || u.hostname.includes("youtu.be")) {
      u.searchParams.set("mute", "1");
      u.searchParams.set("rel", "0");
    }
    return u.toString();
  } catch {
    return url + (url.includes("?") ? "&" : "?") + "autoplay=1";
  }
}
